import { takeLeading, put, call } from "redux-saga/effects";
import { TResult } from "../../../../sg-core";
import {
    IRequestFetchContextLocations,
    createSuccessFetchContextLocations,
    createFailureFetchContextLocations,
    requestContextLocations,
} from "../actions/formContextActions";
import { IFormContextService, ILocationListResult } from "../../services/formContextService";

const makeFetchFormContextLocationsSaga = (formContextService: IFormContextService) =>
    function* saga(action: IRequestFetchContextLocations) {

        try {
            const results: TResult<ILocationListResult> = yield call(formContextService.getLocationList);
            if (results.isSuccess) {
                yield put(createSuccessFetchContextLocations(results.value.locations));
            } else {
                yield put(createFailureFetchContextLocations(results.isFailure ? results.error : new Error()));
            }
        } catch (e) {
            yield put(createFailureFetchContextLocations(e as Error));
        }
    };

export default function create(formContextService: IFormContextService) {
    return takeLeading(
        requestContextLocations,
        makeFetchFormContextLocationsSaga(formContextService),
    );
}
